import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import WomenHub from './pages/WomenHub';
import MenHub from './pages/MenHub';
import GuideWomen30s from './pages/GuideWomen30s';
import GuideWomen40s from './pages/GuideWomen40s';
import GuideWomen50s from './pages/GuideWomen50s';
import GuideWomen60s from './pages/GuideWomen60s';
import GuideMen30s from './pages/GuideMen30s';
import GuideMen40s from './pages/GuideMen40s';
import GuideMen50s from './pages/GuideMen50s';
import GuideMen60s from './pages/GuideMen60s';
import Symptoms from './pages/Symptoms';
import BloodTests from './pages/BloodTests';
import Stacks from './pages/Stacks';
import StackDetail from './pages/StackDetail';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/women" element={<WomenHub />} />
          <Route path="/men" element={<MenHub />} />

          {/* Canonical decade guide URLs (flat, hyphenated) */}
          <Route path="/women-30s" element={<GuideWomen30s />} />
          <Route path="/women-40s" element={<GuideWomen40s />} />
          <Route path="/women-50s" element={<GuideWomen50s />} />
          <Route path="/women-60s" element={<GuideWomen60s />} />
          <Route path="/men-30s" element={<GuideMen30s />} />
          <Route path="/men-40s" element={<GuideMen40s />} />
          <Route path="/men-50s" element={<GuideMen50s />} />
          <Route path="/men-60s" element={<GuideMen60s />} />

          {/* Legacy nested URLs — kept working for any existing inbound
              links (e.g. already-published Quill posts) rather than
              breaking them; the flat URLs above are canonical everywhere
              new links are generated. */}
          <Route path="/women/30s" element={<GuideWomen30s />} />
          <Route path="/women/40s" element={<GuideWomen40s />} />
          <Route path="/women/50s" element={<GuideWomen50s />} />
          <Route path="/women/60s" element={<GuideWomen60s />} />
          <Route path="/men/30s" element={<GuideMen30s />} />
          <Route path="/men/40s" element={<GuideMen40s />} />
          <Route path="/men/50s" element={<GuideMen50s />} />
          <Route path="/men/60s" element={<GuideMen60s />} />
          <Route path="/symptoms" element={<Symptoms />} />
          <Route path="/blood-tests" element={<BloodTests />} />
          <Route path="/stacks" element={<Stacks />} />
          <Route path="/stacks/:slug" element={<StackDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
